import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/wcandillon/tmp/tmp/react-native-redash/packages/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "animations"
    }}>{`Animations`}</h1>
    <hr></hr>
    <h2 {...{
      "id": "mix"
    }}><inlineCode parentName="h2">{`mix()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const mix: (value: Animated.Adaptable<number>, x: Animated.Adaptable<number>, y: Animated.Adaptable<number>) => Animated.Node<number>;
`}</code></pre>
    <p><inlineCode parentName="p">{`mix()`}</inlineCode>{` performs a linear interpolation between x and y using a to weight between them. The return value is computed as `}<inlineCode parentName="p">{`x * (1 - value) + y * value`}</inlineCode>{`.`}</p>
    <hr></hr>
    <h2 {...{
      "id": "tween2d"
    }}><inlineCode parentName="h2">{`tween2d()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const tween2d: (value: Animated.Adaptable<number>, src: Transform2d, dst: Transform2d) => Transform2d;
`}</code></pre>
    <p><inlineCode parentName="p">{`tween2d()`}</inlineCode>{` interpolates from any 2d transformation to any other 2d transformation.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const src = [
  { rotateZ: Math.PI / 2}
  { scale: 0.5 }
];
const dst = [
  { skewX: Math.PI / 6 }
];
const progress = useLoop(1000);
const transform = tween2d(progress, src, dst);
return (
  <Animated.View style={{ transform }}>
    <Card type={Cards.Card1} />
  </Animated.View>
)
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "snappoint"
    }}><inlineCode parentName="h2">{`snapPoint()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const snapPoint: (value: Animated.Adaptable<number>, velocity: Animated.Adaptable<number>, points: Animated.Adaptable<number>[]) => Animated.Adaptable<number>;
`}</code></pre>
    <p>{`Select a point based on a node value and its velocity.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      